import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import ClientTable from './components/ClientTable'
import ClientForm from './components/ClientForm'
import ClientLog from './components/ClientLogs'

// Breadcrumbs
const crmBreadcrumb: PageLink = {title: 'CRM', path: '/', isSeparator: false, isActive: false}
const crmClientBreadcrumb: PageLink = {
  title: 'Client',
  path: '/crm/client',
  isSeparator: false,
  isActive: true,
}

function ClientPage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Client</PageTitle>
              <ClientTable />
            </>
          }
        />
        <Route
          path='/client-log/:id'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb,crmClientBreadcrumb]}>Client Log</PageTitle>
              <ClientLog />
            </>
          }
        />

        <Route
          path='/add'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmClientBreadcrumb]}>
                Add Client
              </PageTitle>
              <ClientForm />
            </>
          }
        />

        <Route
          path='/edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmClientBreadcrumb]}>
                Edit Client
              </PageTitle>
              <ClientForm />
            </>
          }
        />
      </Route>

      {/* Page Not Found */}
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default ClientPage
